import React from "react"

import { ButtonDropdownElement } from "../../../elements/buttonDropdown.element"
import type { IButtonDropdownOption } from "../../../types/objects.types"

import chevronDownIcon from "@front-shared/assets/images/icons/chevron-down-dark.svg"

export const CsvActionsDropdownComponent: React.FunctionComponent<
    ICsvActionsDropdownComponentProps
> = props => {
    const onDownloadTemplate = () => {
        window.open(props.templateUrl, "_blank", "noopener,noreferrer")
    }

    const options: IButtonDropdownOption[] = [
        {
            label: "Download CSV template",
            onClick: onDownloadTemplate,
        },

        ...(props.canUpload
            ? [
                  {
                      label: props.uploadLabel,
                      onClick: props.onUpload,
                  },
              ]
            : []),

        {
            label: props.downloadLabel,
            onClick: props.onDownload,
            isDisabled: props.isDownloadDisabled,
        },
    ]

    return (
        <ButtonDropdownElement
            className={props.className}
            buttonLabel={`CSV${
                props.isExportLoading
                    ? ` (${props.exportProgress ?? 0}%)`
                    : "..."
            }`}
            buttonType="default"
            buttonIcon={chevronDownIcon}
            buttonIsRightIcon
            buttonIsLoading={props.isExportLoading}
            dropdownClassName="min-w-[240px]"
            buttonClassName="
                rounded-[22px] px-[16px] py-[13px]
                bg-brand-warmLight border border-solid
                border-brand-primary hover:bg-brand-lilacLight
            "
            options={options}
        />
    )
}

interface ICsvActionsDropdownComponentProps {
    className?: string
    templateUrl: string
    canUpload: boolean
    uploadLabel: string
    onUpload: () => void
    downloadLabel: string
    onDownload: () => void
    isDownloadDisabled?: boolean
    isExportLoading?: boolean
    exportProgress?: number
}
